
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rules/mine",
      function () {
        return require("private-next-pages/rules/mine.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rules/mine"])
      });
    }
  